import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Hero from '@/components/Hero'
import Summary from '@/components/Summary'
import { Columns } from '@/components/Article/style.css'
import { Content } from '@/components/Rankings/style.css'
import { Link } from 'gatsby'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Ranking de universidades Chilenas 2022"
      keywords={[
        `La Tercera`,
        `Ranking Universidades Chilenas 2022`,
        `Ranking Universidades`,
      ]}
    />
    <Hero />
    <Summary />

    <div className="container max-w-5xl mx-auto">
      <Content>
        <h1 className="text-center">
          <strong>¿Qué mide el</strong> Ranking de Universidades?
        </h1>
        <Columns>
          <p>
            El ranking se construye con cinco dimensiones: percepción de la
            calidad que el mercado laboral le otorga a cada una de las
            universidades, gestión, calidad del cuerpo académico, calidad de los
            alumnos y los niveles de investigación de las instituciones.
          </p>

          <p>
            Cada uno de estos factores tiene un determinado valor porcentual en
            el ranking general. Así, la metodología presenta un mix cualitativo
            y cuantitativo. El primero se basa en una encuesta de percepción de
            calidad del mercado laboral, cuyo levantamiento de datos lo realizó
            la empresa de estudio e investigación de mercados Feedback; mientras
            que la información referente a gestión, académicos y alumnos es
            extraída del portal www.mifuturo.cl, del Mineduc, y la de
            investigación es proporcionada por SCImago Research Group. Dada la
            relevancia de cada dimensión se elaboran rankings independientes, de
            modo que pueden consultarse de acuerdo con los intereses de cada
            lector. Para trabajar con índices sintéticos expresados en
            diferentes medidas, estos se normalizaron estadísticamente,
            reescalando respecto del máximo parámetro de cada variable,
            otorgando el valor 100 a la institución que presenta el indicador
            con mejor desempeño. En cuanto a las ponderaciones, un 40% tiene el
            Ranking de percepción de calidad del mercado laboral y un 15% cada
            uno de los otros rankings: gestión institucional, calidad de
            alumnos, calidad de los académicos e investigación. La suma de ellos
            arroja el índice ponderado, que jerarquiza a las universidades en
            orden descendente.
          </p>
        </Columns>
        <h1 className="text-center">
          <strong>¿Cuántas</strong> universidades son evaluadas?
        </h1>
        <Columns>
          <p>
            Son 47 casas de estudio las que cuentan con acreditación
            institucional, registran la información que se utiliza disponible en
            las bases de datos públicas del Servicio de Información de Estudios
            Superiores (SIES), del Ministerio de Educación, y de la Comisión
            Nacional de Acreditación. Así, se excluyen las universidades no
            acreditadas: la U. de Aconcagua, U. del Alba y U. Bolivariana. Por
            otra parte, las dos universidades estatales que fueron fundadas en
            2015, U. de Aysén y U. de O ́Higgins, no pueden ser ranqueadas ya que
            aún no cuentan con acreditación institucional. Este año ingresaron
            las universidades Gabriela Mistral, Miguel de Cervantes, UNIACC y
            SEK.
          </p>
        </Columns>
      </Content>
    </div>
  </Layout>
)

export default IndexPage
